export default __webpack_public_path__ + "static/media/yo.d75ff1a8.jpg";